import publicClient from "./public-client";
import { HOST_GROWME } from "../../helpers/constants";

export default class PublicCatalogAPI {
  static getCatalog() {
    return publicClient.get(`${HOST_GROWME}/catalog`);
  }
}
